import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface SimplesNacionalInicio {
  error?: string;
  jobId: string;
  empresas: string[];
}

export interface SimplesNacionalEmpresaStatus {
  nome: string;
  status: string;
  cnpjs: number;
  comprovantes: number;
  cnpjsConcluidos: string[];
  erro?: string | null;
}

export interface SimplesNacionalStatus {
  jobId: string;
  status: string;
  empresaAtual?: string | null;
  erro?: string | null;
  arquivoPronto: boolean;
  empresas: SimplesNacionalEmpresaStatus[];
}

@Injectable({ providedIn: 'root' })
export class SimplesNacionalService {
  private readonly base = `${environment.apiUrl}/v1/simples-nacional`;

  constructor(private readonly http: HttpClient) {}

  enviar(planilha: File): Observable<SimplesNacionalInicio> {
    const form = new FormData();
    form.append('planilha', planilha, planilha.name);
    return this.http.post<SimplesNacionalInicio>(`${this.base}/planilha`, form);
  }

  consultar(jobId: string): Observable<SimplesNacionalStatus> {
    return this.http.get<SimplesNacionalStatus>(`${this.base}/planilha/${jobId}`);
  }

  baixar(jobId: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.base}/planilha/${jobId}/arquivo`, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
